/**
 * usePageContext — Auto-sync current route to ChatContextStore
 *
 * Drop this in any layout or page to automatically set
 * the AI chat context for that page. The AI chat sidebar
 * will then know which page the user is on and offer
 * contextual quick actions.
 */

import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useChatContextStore, routeToPageContext } from '@/stores/chat-context-store';

export function usePageContext() {
  const location = useLocation();
  const params = useParams();
  const setPageContext = useChatContextStore((s) => s.setPageContext);
  const paramsKey = JSON.stringify(params);

  useEffect(() => {
    const ctx = routeToPageContext(location.pathname, params as Record<string, string>);
    setPageContext(ctx);
  }, [location.pathname, paramsKey, setPageContext]);
}
